var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.00001H6.8C5.11984 4.00001 4.27976 4.00001 3.63803 4.32699C3.07354 4.61461 2.6146 5.07356 2.32698 5.63804C2 6.27978 2 7.11986 2 8.80001V17.2C2 18.8802 2 19.7203 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7203 20 18.8802 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9448C10.8425 15.8958 11.0376 15.815 11.2166 15.7053C11.4184 15.5816 11.5914 15.4087 11.9373 15.0628L21.5 5.50001C22.3284 4.67159 22.3284 3.32844 21.5 2.50001C20.6716 1.67159 19.3284 1.67159 18.5 2.50001L8.93723 12.0628C8.59133 12.4087 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1575 8.05523 13.3616C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBox);
export default __webpack_public_path__ + "static/media/editBox.c3e8b0abfb8063b67abfdab1768b1574.svg";
export { ForwardRef as ReactComponent };